import { render, staticRenderFns } from "./TownDetail.vue?vue&type=template&id=4ac078b1&scoped=true&"
import script from "./TownDetail.vue?vue&type=script&lang=js&"
export * from "./TownDetail.vue?vue&type=script&lang=js&"
import style0 from "./TownDetail.vue?vue&type=style&index=0&id=4ac078b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac078b1",
  null
  
)

export default component.exports